<script setup>
import { computed, onMounted } from 'vue';
import { useRoute, RouterLink } from 'vue-router';
import { useScrollStore } from '@/stores/storeScroll';

const route = useRoute();
const storeScroll = useScrollStore();

const isNotFinedPage = computed(() => route.name === '404')
onMounted(() => {
   
})

</script>
<template>
    <section class="not-page" :style="{paddingTop: storeScroll.header?.offsetHeight + 'px'}">
        <div class="container">
            <div class="not-page__container">
                <div class="not-page__numbers">
                    <span>4</span>
                    <span>0</span>
                    <span>4</span>
                </div>
                <h1 class="not-page__title">Страница не найдена</h1>
                <RouterLink to="/" class="not-page__btn btn ">На главную</RouterLink>
            </div>
        </div>
    </section>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';

.not-page {
    position: relative;
    padding-top: 30px;
}

.not-page__container {
    padding-top: 6.2rem;
    padding-bottom: 12rem;    
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3.3rem;
    @media (max-width: vars.$x480) {
        padding-top: 3.2rem;
        padding-bottom: 4rem; 
        gap: 1rem;
    }
}
.not-page__title {
    font-weight: 900;
    font-size: 6rem;
    line-height: 160%;
    text-transform: uppercase;
    text-align: center;
    color: #1d1d1b;
    // margin-bottom: 3rem;
    @media (max-width: vars.$x480) {
        font-size: 2rem;
        // margin-bottom: 2rem;
    }
}
.not-page__btn {
    padding-left: 5.4rem;
    padding-right: 5.4rem;
    @media (max-width: vars.$x480) {
      
    }
}
.not-page__numbers {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    span {
        font-weight: 900;
        font-size: 30.9rem;
        line-height: 90%;
        text-transform: uppercase;
        text-align: center;
        color: var(--text-accent-2-100);
        @media (max-width: vars.$xx) {
            font-size: 16rem;
        }
    }

    img {
        @media (max-width: vars.$m) {
            width: 40%;
        }
    }
}

</style>